export const APP_CONFIG = {
  phone: "22392922627"
};